import React from 'react'

const TouchDeviceContext = React.createContext(true)

export default TouchDeviceContext
